var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.302 7.644 9.12 11.438c-.191.173-.45.27-.721.271-.27 0-.53-.098-.72-.27L3.498 7.644A.88.88 0 0 1 3.2 6.99c0-.236.1-.473.299-.654a1.095 1.095 0 0 1 1.442 0l2.475 2.246V1.434c0-.511.456-.925 1.018-.925.564 0 1.02.414 1.02.925V8.52l2.407-2.184a1.09 1.09 0 0 1 1.44 0 .865.865 0 0 1 0 1.308M1.834 14.636v-3.59a.927.927 0 0 0-.916-.937.93.93 0 0 0-.918.937v3.712c0 .966.77 1.751 1.715 1.751h12.57c.946 0 1.715-.785 1.715-1.751v-3.712a.927.927 0 0 0-.917-.937.927.927 0 0 0-.917.937v3.59z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;